import { Button, Text } from '@billda/design-system';
import { ActivityTimeline } from './ActivityTimeline';
import type { BaseEventTimelineItem } from '../../../types/eventTimeline';

interface PagedActivityTimelineProps {
  events: BaseEventTimelineItem[];
  totalCount: number;
  hasMore: boolean;
  isLoading: boolean;
  isLoadingMore: boolean;
  loadMore: () => void;
}

export function PagedActivityTimeline({
  events,
  totalCount,
  hasMore,
  isLoading,
  isLoadingMore,
  loadMore,
}: PagedActivityTimelineProps) {
  return (
    <div>
      <ActivityTimeline events={events} isLoading={isLoading} />
      {hasMore && (
        <Button
          variant="outline"
          onClick={loadMore}
          disabled={isLoadingMore}
          fullWidth
          className="mt-4"
        >
          {isLoadingMore ? 'Loading...' : 'Load More'}
        </Button>
      )}
      {hasMore && !isLoading && (
        <Text
          variant="caption"
          color="disabled"
          className="mt-2 block text-center"
        >
          Showing {events.length} of {totalCount}
        </Text>
      )}
    </div>
  );
}
